export default "__VITE_ASSET__SNcOyURW__"